import React, { useMemo } from "react";
import DetailLayout from "../components/DetailLayout";
import VoteHeader from "./components/VoteHeader";
import style from "./index.module.scss";
import VoteResult from "./components/VoteResult";
import VoteStuList from "./components/VoteStuList";
import { RouteComponentProps } from "react-router-dom";
import useRequest from "utils/useRequest";
import {
    getResultFromVoteList,
    getVotePaperContent,
    voteInfoList,
    VoteState
} from "service/vote";
import { toNumber } from "service/service";
import { Spin } from "antd";
import VoteStuTable from "./components/VoteStuTable";

interface VoteDetailProps {
    voteId: string;
}

export default function VoteDetail({
    match
}: RouteComponentProps<VoteDetailProps>) {
    const { voteId } = match.params;
    const [data, , refreshData] = useRequest(() =>
        getVotePaperContent(toNumber(voteId))
    );
    const [list, , refreshList] = useRequest(() =>
        voteInfoList(toNumber(voteId))
    );

    // 投票结果
    const voteResult = useMemo(() => {
        if (!list || !data) return [];
        return getResultFromVoteList(data.type, data.answersNumber, list);
    }, [list, data]);

    function refreshAll() {
        refreshList();
        refreshData();
    }

    return (
        <DetailLayout breadcrumb="投票详情">
            <Spin spinning={!data || !list}>
                <VoteHeader
                    data={data}
                    onChange={refreshAll}
                    onCountDown={refreshAll}
                />

                {data && data.status !== VoteState.Done && (
                    <div className={style.main}>
                        <VoteResult
                            data={voteResult}
                            total={list?.length || 1}
                        />
                        <VoteStuList data={list || []} />
                    </div>
                )}

                {data && data.status === VoteState.Done && (
                    <VoteStuTable voteInfo={data} stuList={list || []} />
                )}
            </Spin>
        </DetailLayout>
    );
}
